import { supabase } from "@/integrations/supabase/client";

/**
 * Calls the verify-turnstile edge function. Fails closed: any non-success
 * response (including network errors) returns false.
 */
export async function verifyTurnstile(token: string | null, action: string): Promise<boolean> {
  if (!token) return false;
  try {
    const { data, error } = await supabase.functions.invoke("verify-turnstile", {
      body: { token, action },
    });
    if (error) {
      console.warn("[turnstile] verification error", error);
      return false;
    }
    return !!(data && (data as { success?: boolean }).success);
  } catch (err) {
    console.warn("[turnstile] verification threw", err);
    return false;
  }
}
